import React, { useEffect } from 'react';

interface NotesModalProps {
    isOpen: boolean;
    onClose: () => void;
    notes: string | null;
    title: string;
}

export const NotesModal: React.FC<NotesModalProps> = ({
    isOpen,
    onClose,
    notes,
    title
}) => {

    useEffect(() => {
        if (!isOpen) return;

        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    });
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end z-50">
            <div className="bg-white w-full max-w-md h-full overflow-y-auto shadow-xl">
                <div className="p-6">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-bold text-[#0F2A4F] inter-bold">{title}</h2>
                        <button
                            onClick={onClose}
                            className="rounded-full p-2 hover:bg-gray-100"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div className="mb-4">
                        <div className="w-full px-3 py-2 border border-gray-300 rounded-md h-64 overflow-y-auto">
                            <p className="text-gray-700 whitespace-pre-wrap inter-regular">{notes || '--'}</p>
                        </div>
                    </div>

                    <div className="mt-6 flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-[#0F2A4F] text-white rounded-md hover:bg-[#1e3c68] inter-medium"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
